import { RemoteIssuanceCardsStatsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const issuanceCardsStatsService = new RemoteIssuanceCardsStatsService(httpClient)
